import React, { useState } from 'react';
import { Monitor, Battery, Keyboard, HardDrive, Cpu, Shield, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { services } from '../mockData';

const iconComponents = {
  Monitor,
  Battery,
  Keyboard,
  HardDrive,
  Cpu,
  Shield
};

const Services = () => {
  const [hoveredService, setHoveredService] = useState(null);

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2E3C5B]">
            Our Premium Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional laptop repair and maintenance services by certified technicians
          </p>
          <div className="w-24 h-1 bg-[#E94B3C] mx-auto rounded-full"></div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconComponents[service.icon];
            return (
              <Card
                key={service.id}
                onMouseEnter={() => setHoveredService(service.id)}
                onMouseLeave={() => setHoveredService(null)}
                className={`p-8 border-2 transition-all duration-300 cursor-pointer group ${
                  hoveredService === service.id
                    ? 'border-[#E94B3C] shadow-2xl -translate-y-2 bg-gradient-to-br from-white to-gray-50'
                    : 'border-gray-200 hover:border-[#2E3C5B] shadow-lg hover:shadow-xl'
                }`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="space-y-4">
                  {/* Icon */}
                  <div className={`w-16 h-16 rounded-xl flex items-center justify-center transition-all duration-300 ${
                    hoveredService === service.id
                      ? 'bg-[#E94B3C] scale-110 rotate-3'
                      : 'bg-[#2E3C5B] group-hover:bg-[#E94B3C]'
                  }`}>
                    <IconComponent className="text-white" size={32} />
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-[#2E3C5B] group-hover:text-[#E94B3C] transition-colors">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Learn More Button */}
                  <Button
                    variant="ghost"
                    className={`text-[#2E3C5B] hover:text-[#E94B3C] p-0 h-auto font-semibold group/btn transition-all ${
                      hoveredService === service.id ? 'translate-x-2' : ''
                    }`}
                  >
                    Learn More
                    <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform" size={18} />
                  </Button>
                </div>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col md:flex-row items-center gap-4 bg-gradient-to-r from-[#2E3C5B] to-[#1f2a3f] p-8 rounded-2xl shadow-2xl">
            <div className="text-white text-left md:text-left">
              <h3 className="text-2xl font-bold mb-2">Need a Custom Solution?</h3>
              <p className="text-gray-200">Our experts are ready to help with any laptop issue</p>
            </div>
            <Button
              size="lg"
              className="bg-[#E94B3C] hover:bg-[#d43d2c] text-white border-0 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
            onClick={() => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  }}
            >
              Contact Support
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
